import {
  // RaffleEntry,
  RaffleEntryCollection,
} from "../../pages/RaffflePage/types/RafffleTypes";
import { ICollection } from "../Collection/CollectionTypes";
import { LendingStatus } from "../Lending/LendingTypes";
import { IOwnerInfo } from "../Owner/OwnerTypes";
import { IRaffle } from "../Raffle/RaffleTypes";
import { ISaleEntry } from "../Sale/SaleTypes";

// MARK: nfts/owner DOMAIN
export interface IFullNftOwner {
  address: string;
  nftItem: INFTItem;
  collection: ICollection;
  ownerAddress: string;
  status: NFTStatus | null;
  indirectOwnerAddress: string | null;
}

export interface INFT {
  address: string;
  collection: ICollection;
  nftItem: INFTItem;
  currentSale: ISaleEntry | null;
  lastSale: ISaleEntry | null;
  currentRaffle: IRaffle | null;
  currentNftAuction: IFormattedNFTAuction | null;
  ownerAddress: string;
  indirectOwnerAddress: string | null;
  status: NFTStatus | null;
  currentOtherSale: IFormattedOtherContractSale | null;
  attributes: INFTAttributeWithCalc[];
  nftAdditionalInfo: IFormattedNftAdditionalInfo[] | null;
  currentLending: IFormattedNFTLending | null;
  currentOtherAuction: IFormattedOtherContractAuction | null;
}

export interface IFormattedOtherContractAuction {
  id: number;
  address: string;
  created: string;
  ownerAddress: string;
  versionHash: string | null;
  createdAt: string | null;
  maxBid: string | null;
  contractType: string | null;
  collectionId: number | null;
  nftId: number;
  marketplaceFee: string;
  royalty: string;
  isCompleted: boolean;
  isCanceled: boolean;
  closeDate: string;
  isBrokenAuction?: boolean;
}

export interface IFormattedNFTLending {
  address: string;
  ownerAddress: string;
  status: LendingStatus;
  amountUnified: string;
  amount: string;
  nftId: number;
  accepted: string | null;
  offerAddress: string | null;
  lenderAddress: string | null;
  closeDate: string | null;
}

export interface IFormattedOtherContractSale {
  id: number;
  address: string;
  created: string;
  ownerAddress: string;
  versionHash: string | null;
  createdAt: string | null;
  price: string | null;
  contractType: string | null;
  collectionId: number | null;
  nftId: number;
  marketplaceFee: string;
  royalty: string;
  isActive: boolean;
}

// NOTE: Backend response type to resync NFT owner
export interface INFTOwner {
  address: string;
  ownerAddress: string | null;
  nftItem: INFTItem;
  status: NFTStatus | null;
  indirectOwnerAddress: string | null;
}

export enum NFTStatus {
  ON_RAFFLE = "ON_RAFFLE",
  ON_SALE = "ON_SALE",
  ON_OTHER_SALE = "ON_OTHER_SALE",
  ON_WALLET = "ON_WALLET",
  ON_OTHER_CONTRACT = "ON_OTHER_CONTRACT",
  BURNED = "BURNED",
  NFT_AUCTION_SALE = "NFT_AUCTION_SALE",
  ON_OTHER_BROCKEN_SALE = "ON_OTHER_BROCKEN_SALE",
  ON_LENDING = "ON_LENDING",
  ACCEPTED_LENDING = "ACCEPTED_LENDING",
  ON_OTHER_AUCTION = "ON_OTHER_AUCTION",
}

export interface INFTItem {
  address: string;
  approved_by: string[];
  collection: RaffleEntryCollection; // TODO: maybe create new one
  index: number;
  metadata: NFTMetadata;
  owner: IOwnerInfo;
  previews: NFTPreview[];
  trust: string;
  verified: boolean;
}

export type NFTPreview = {
  resolution: string;
  url: string;
};

export type NFTMetadata = {
  attributes: NFTAttribute[];
  buttons: NFTButton[];
  name: string;
  image: string;
  marketplace: string;
  description: string;
};

export type NFTAttribute = {
  value: string;
  trait_type: string;
};

export type NFTButton = {
  uri: string;
  label: string;
};

export interface NFTItemsFilterType {
  ALL: number;
  NOT_FOR_SALE: number;
  ON_RAFFLE: number;
  ON_SALE: number;
  ON_OTHER_SALE: number;
  ON_LENDING: number;
}

export enum NFTItemsStatusType {
  ALL = "ALL",
  NOT_FOR_SALE = "NOT_FOR_SALE",
  ON_RAFFLE = "ON_RAFFLE",
  ON_SALE = "ON_SALE",
  ON_OTHER_SALE = "ON_OTHER_SALE",
  ON_LENDING = "ON_LENDING",
}

export enum NFTItemsOwnerType {
  ALL = "All",
  MY = "My NFTs",
  OTHER = "Not my NFTs",
}

export interface IFormattedNFTAuction {
  id: number;
  ownerAddress: string | null;
  collectionId: number;
  config: IFormattedNFTAuctionConfig;
  endedAt: string | null;
  maxBid: string | null;
  nftId: number;
  state: IFormattedNFTAuctionState | null;
}

export interface IFormattedNFTAuctionConfig {
  beneficiaryAddress: string | null;
  initialMinBid: string;
  maxBid: string;
  minBidStep: string;
  minExtendTime: number;
  duration: number;
}

export interface IFormattedNFTAuctionState {
  bidderAddress: string | null;
  bid: string;
  bidTs: string;
  minBid: string;
  endTime: number;
}
export interface INFTAttributeWithCalc {
  nftId: number;
  collectionId: number;
  type: string;
  hash: string;
  value: string;
  count: number;
  percent: number;
}

export interface IFormattedNftTransfer {
  fromAddress: string;
  toAddress: string;
  fromType: string;
  toType: string;
  hash: string;
  opcode: string;
  utime: string;
  lt: number;
  nftId: number;
  collectionId: number;
  status: NftTransferStatus;
  price: string | null;
  traceHash: string | null;
}

export enum NftTransferStatus {
  TRANSFER = "TRANSFER",
  BURNED = "BURNED",
  SALE = "SALE",
  SALE_PLACE = "SALE_PLACE",
  SALE_CANCEL = "SALE_CANCEL",
  SALE_EDIT = "SALE_EDIT",
  RAFFLE = "RAFFLE",
  RAFFLE_PLACE = "RAFFLE_PLACE",
  RAFFLE_CANCEL = "RAFFLE_CANCEL",
  COLLECTION_OFFER = "COLLECTION_OFFER",
  MINTED = "MINTED",
  STAKING = "STAKING",
  LENDING = "LENDING",
  CREATE_LENDING = "CREATE_LENDING",
  CANCEL_LENDING = "CANCEL_LENDING",
  AUCTION_START = "AUCTION_START",
  AUCTION_END = "AUCTION_END",
  AUCTION_CANCEL = "AUCTION_CANCEL",
  NFT_OFFER = "NFT_OFFER",
}

export enum NftTransferSortOrder {
  TRANSFER_ASC = "transfer_asc",
  TRANSFER_DESC = "transfer_desc",
}

export interface IGetFormattedNftTransfers {
  transfers: IFormattedNftTransfer[];
  statuses: IFormattedNftStatusesTransfer[];
}
export interface IFormattedNftStatusesTransfer {
  status: NftTransferStatus;
  count: number;
}

export interface IGetNftTransfersQueryRequest {
  sort?: NftTransferSortOrder;
  limit?: number;
  offset?: number;
  status?: NftTransferStatus;
}
export interface IFormattedNftAdditionalInfo {
  source: NftAdditionalInfoSource;
  type: NftAdditionalInfoType;
  collectionId: number;
  nftId: number;
  state: object | null;
}
export enum NftAdditionalInfoType {
  BANNED = "banned",
}

export enum NftAdditionalInfoSource {
  FRAGMENT = "fragment",
}

export interface INFTStatistics {
  nftOwnersCount: number;
  events: INFTStatisticsEvent[];
}

export interface INFTStatisticsEvent {
  count: number;
  date: string;
  maxPrice: string;
  avgPrice: string;
}
